module.exports = __webpack_public_path__ + "img/zhibanbiao.3c7087f7.png";